export enum PatientAttachmentHistoryItemActions {
  created = 'created',
  submitted = 'submitted',
  transitioned = 'transitioned',
  assignmentNew = 'assignment_new',
  assignmentUpdated = 'assignment_updated',
  assignmentRemoved = 'assignment_removed',
}
